import React from "react";
import { Link } from "react-router-dom";
import PageShell from "@/components/PageShell";
import { ArrowLeft } from "lucide-react";

const NotFound = () => {
  return (
    <PageShell>
      <section className="relative">
        <div className="mx-auto max-w-3xl px-4 py-20 md:py-28 text-center">
          <div
            className="inline-block text-7xl md:text-8xl font-extrabold"
            style={{
              fontFamily: "Sora, Inter, sans-serif",
              background: "linear-gradient(90deg,#15A76C 0%,#7B5CE0 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
            }}
          >
            404
          </div>
          <h1
            className="mt-3 text-3xl md:text-4xl font-extrabold text-[#0B1D3A]"
            style={{ fontFamily: "Sora, Inter, sans-serif" }}
          >
            Route not found
          </h1>
          <p className="mt-3 text-[#33406B]">
            This page didn't check in. Let's route you back to base.
          </p>
          <Link
            to="/"
            className="sn-btn-primary inline-flex items-center gap-2 px-5 py-3 rounded-xl text-sm font-semibold mt-6"
          >
            <ArrowLeft size={16} /> Back to Landing
          </Link>
        </div>
      </section>
    </PageShell>
  );
};

export default NotFound;
